import type { MagentoStoreConfig } from "@jti/fe-common";
import type { CartStoreConfig } from "@jti/store/slices/cartSlice";
import { initialCartState } from "@jti/store/slices/cartSlice";

export const toCartStoreConfig = (storeConfig: MagentoStoreConfig): CartStoreConfig => ({
  ...storeConfig,
  cartons_limit_value: storeConfig.cartons_limit_value ?? initialCartState.storeConfig.cartons_limit_value,
});
